import services from '@/config/services'
import FileManager from '@/services/ask-file-manager/index.js'
export default class AgentiService{
  
  constructor(http, eventBus){
    this.http = http
    this.eventBus = eventBus
    this.baseUrl = `${services.ask_api.url}/management`
    this.basePraticheUrl = `${services.ask_pratiche.url}`
    this.baseApi = `${services.ask_base_api.url}`
    this.filemanager = new FileManager()
  }

  async getAllItemsForMindTable(opts = {}){
    let items = []
    let totalItems = 0

    const url = `${this.baseUrl}/agenti/search`
    
    try {
      let res = await this.http.post(url, {filters: opts})
      res = res.data

      items = res.data
      totalItems = res.meta.total_items
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
      this.eventBus.emit('data-loaded')
      
      // eslint-disable-next-line no-unsafe-finally
      return {
        items,
        total: totalItems,
      }
    }
  }

  getAllColumnsForMindTable(){
    return [
      {
        property: 'name',
        label: 'Nome Cognome',
        sortable: true,
        default: true,
      },
      {
        property: "email",
        label: "Email",
        default: true,
      },
      {
        property: "telefono",
        label: "Telefono",
        default: true,
      },
      {
        property: "partita_iva",
        label: "Partita iva",
        default: true,
      },
      {
        property: "note",
        label: "Note",
        default: true,
      },
      
    ]
  }

  async getDettaglioAgente(id){
    let item = {}

    const url = `${this.baseUrl}/clienti/agenti/${id}`
    try {
      let res = await this.http.get(url)
      res = res.data

      item = res.data
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
      this.eventBus.emit('data-loaded')
      
      // eslint-disable-next-line no-unsafe-finally
      return {
        item
      }
    }
  }
  async getAndamentoAgente(id){
    let item = {}

    const url = `${this.baseUrl}/clienti/agenti/${id}/andamento`
    try {
      let res = await this.http.get(url)
      res = res.data

      item = res.data
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
      this.eventBus.emit('data-loaded')
      
      // eslint-disable-next-line no-unsafe-finally
      return {
        item
      }
    }
  }
  async getOfferteAgente(id){
    let item = {}

    const url = `${this.baseUrl}/clienti/agenti/${id}/offerte`
    try {
      let res = await this.http.get(url)
      res = res.data

      item = res.data
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
      this.eventBus.emit('data-loaded')
      
      // eslint-disable-next-line no-unsafe-finally
      return {
        item
      }
    }
  }
  async getSubagentiAgente(id){
    let item = {}

    const url = `${this.baseUrl}/clienti/agenti/${id}/subagenti`
    try {
      let res = await this.http.get(url)
      res = res.data

      item = res.data
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
      this.eventBus.emit('data-loaded')
      
      // eslint-disable-next-line no-unsafe-finally
      return {
        item
      }
    }
  }
  async getTreeSubagentiAgente(id){
    let item = {}

    const url = `${this.baseUrl}/clienti/agenti/${id}/tree-subagenti`
    try {
      let res = await this.http.get(url)
      res = res.data

      item = res.data
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
      this.eventBus.emit('data-loaded')
      
      // eslint-disable-next-line no-unsafe-finally
      return {
        item
      }
    }
  }
  async getTreeSubagentiFlatAgente(id){
    let item = {}

    const url = `${this.baseUrl}/clienti/agenti/${id}/tree-subagenti-flat`
    try {
      let res = await this.http.get(url)
      res = res.data

      item = res.data
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
      this.eventBus.emit('data-loaded')
      
      // eslint-disable-next-line no-unsafe-finally
      return {
        item
      }
    }
  }

  async updateInfo(id, info){
    let item = {}
    let success = false

    const url = `${this.baseUrl}/clienti/agenti/${id}/info`
    try {
      let res = await this.http.put(url, {data: info})
      res = res.data

      item = res.data
      success = res.meta.success
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
      this.eventBus.emit('data-loaded')
      
      // eslint-disable-next-line no-unsafe-finally
      return {
        item,
        success
      }
    }
  }

  async sendAgentLoginEmail(name, email, area, forceMail, ccnMail){
    let success = false

    const url = `${this.baseApi}/agent/access-email`
    try {
      let res = await this.http.post(url, {name, email, area, forceMail, ccnMail})
      success = res.data.status
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
      this.eventBus.emit('data-loaded')
      
      // eslint-disable-next-line no-unsafe-finally
      return {
        success
      }
    }
  }

  async updateAgentiAccessDate(email){
    let success = false

    const url = `${this.baseUrl}/clienti/agenti/access-date/update`
    try {
      let res = await this.http.post(url, {email, type:'agente'})
      success = res.data
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
      this.eventBus.emit('data-loaded')
      
      // eslint-disable-next-line no-unsafe-finally
      return {
        success
      }
    }
  }

  async changeAgenteCanView(item){   
    let success = false

    const url = `${this.baseUrl}/clienti/agenti/can-view/update`
    try {
      let res = await this.http.post(url, {item})
      success = res.data
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
      this.eventBus.emit('data-loaded')
      
      // eslint-disable-next-line no-unsafe-finally
      return {
        success
      }
    }
  }

  async getTwoFactorAuth(id){
    const url = `${this.basePraticheUrl}/login/agente/otp?id=${id}`
    try {
      const res = await this.http.get(url)
      return res.data?.data?.is_otp ?? false
    } catch (err) {
      return false
    }
  }

  async updateTwoFactorAuth(id, enabled){
    let item = {}
    let success = false

    const url = `${this.basePraticheUrl}/login/agente/otp`
    try {
      let res = await this.http.post(url, { id, is_otp: enabled })
      res = res.data
      item = res.data || {}
      success = res.success ?? true

    } catch (err) {
      this.eventBus.emit('data-load-error', { message: err, url })
    } finally {
      this.eventBus.emit('data-loaded')
    }

    return {
      item,
      success
    }
  }

  async getTipiDocumentoModulistica(){
    let items = []
    const url = `${this.baseUrl}/clienti/agenti/modulo/tipi-documento`
    try {
      let res = await this.http.get(url)
      items = res.data?.data || []
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
      this.eventBus.emit('data-loaded')
      // eslint-disable-next-line no-unsafe-finally
      return { items }
    }
  }

  async uploadModulo(file, idAgente, isGlobal, forceAdmin = false){
    let items = {}
    const settings = { headers: { 'content-type': 'multipart/form-data' } }
    const url = `${this.baseUrl}/clienti/agenti/modulo/upload`
    let fd = new FormData();
    fd.append('title', file.title);
    fd.append('isGlobal', isGlobal);
    fd.append('idAgente', idAgente);
    if (forceAdmin) {
      fd.append('forceAdmin', 1);
    }
    for (let i = 0 ; i < file.file.length ; i++) {
      fd.append('files[]', file.file[i]); 
    }

    try {
      let res = await this.http.post(url, fd , settings)

      items = res.data

    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')
        // eslint-disable-next-line no-unsafe-finally
        return {
          items,
        }
    }

  }


  async downloadAgenteModulo(code){

    const url = `${this.baseUrl}/clienti/agenti/modulo/download`
    try {
        let res = 
        await this.http({
            url,
            method: 'POST',
            data: {code},
            responseType: 'blob',
          })

        this.filemanager.download(res)

    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')   
    }

  }


  async deleteAgenteModulo(code){
    let success = false

    const url = `${this.baseUrl}/clienti/agenti/modulo/delete`
    try {
      let res = await this.http.post(url, {code})
      success = res.data
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
      this.eventBus.emit('data-loaded')
      
      // eslint-disable-next-line no-unsafe-finally
      return {
        success
      }
    }
  }

  async associateAgenteOfferte(agenti,offerte){
    let success = false

    const url = `${this.baseUrl}/clienti/agenti/associate/offerte`
    try {
      let res = await this.http.post(url, {agenti,offerte})
      success = res.data
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
      this.eventBus.emit('data-loaded')
      
      // eslint-disable-next-line no-unsafe-finally
      return {
        success
      }
    }
  }


  async dissociateAgenteOfferte(fd){
    let success = false

    const url = `${this.baseUrl}/clienti/agenti/dissociate/offerte`
    try {
      let res = await this.http.post(url, fd)
      success = res.data
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
      this.eventBus.emit('data-loaded')
      
      // eslint-disable-next-line no-unsafe-finally
      return {
        success
      }
    }
  }
  async associateAgencyToAgent(idAgent, idAgency){
    let success = false

    const url = `${this.baseUrl}/clienti/agenti/associate/agency`
    try {
      let res = await this.http.post(url, {idAgent, idAgency})
      success = res.data
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
      this.eventBus.emit('data-loaded')
      
      // eslint-disable-next-line no-unsafe-finally
      return {
        success
      }
    }
  }
  async associateSubagentsToAgent(idAgent, subagents){
    let success = false

    const url = `${this.baseUrl}/clienti/agenti/associate/subagents`
    try {
      let res = await this.http.post(url, {idAgent, subagents})
      success = res.data
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
      this.eventBus.emit('data-loaded')
      
      // eslint-disable-next-line no-unsafe-finally
      return {
        success
      }
    }
  }

  async dissociateSubagenti(idAgente,subagente){
    let success = false

    const url = `${this.baseUrl}/clienti/agenti/dissociate/subagente`
    try {
      let res = await this.http.post(url, {idAgente,subagente})
      success = res.data
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
      this.eventBus.emit('data-loaded')
      
      // eslint-disable-next-line no-unsafe-finally
      return {
        success
      }
    }
  }


  async applyNewGroupOfferteToAgent(agente,offerte){
    let success = false

    const url = `${this.baseUrl}/agenti/relation/subagents/tree/offerte/associate`
    try {
      let res = await this.http.post(url, {agente,offerte})
      success = res.data
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
      this.eventBus.emit('data-loaded')
      
      // eslint-disable-next-line no-unsafe-finally
      return {
        success
      }
    }
  }

  async getAgentsReportPdp(year){
    let items = {}

    const url = `${this.baseUrl}/clienti/agenti/pdp/report/${year}`
    try {
      let res = await this.http.get(url, {year})
      items = res.data
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
      this.eventBus.emit('data-loaded')
      
      // eslint-disable-next-line no-unsafe-finally
      return {
        items
      }
    }
  }

  async getCities(value = null){
    let items = {}
    const url = `${this.basePraticheUrl}/get-cities/${value}`

    try {
      let res = await this.http.get(url)
        items = res.data
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
        // eslint-disable-next-line no-unsafe-finally
        return {
            items,
        }
    }
  }
  async getGettoni(value = null){
    let items = {}
    const url = `${this.baseUrl}/clienti/agenti/get-gettoni/${value}`

    try {
      let res = await this.http.get(url)
        items = res.data
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
        // eslint-disable-next-line no-unsafe-finally
        return {
            items,
        }
    }
  }

  async getScaglioni(value = null){
    let items = {}
    const url = `${this.baseUrl}/clienti/agenti/get-scaglioni/${value}`

    try {
      let res = await this.http.get(url)
        items = res.data
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
        // eslint-disable-next-line no-unsafe-finally
        return {
            items,
        }
    }
  }

  async saveNewScaglione(id, scaglione){
    let items = {}
    const url = `${this.baseUrl}/clienti/agenti/save-new-scaglione`

    try {
      let res = await this.http.post(url, {'id':id, 'scaglione': scaglione})
        items = res.data
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
        // eslint-disable-next-line no-unsafe-finally
        return {
            items,
        }
    }
  }

  async saveGettoni(new_gettoni_offerta){
    let items = {}

    const url = `${this.baseUrl}/clienti/agenti/save-gettone`
    
    try {
      let res = await this.http.post(url, new_gettoni_offerta)
      items = res.data

    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
      this.eventBus.emit('data-loaded')      
      // eslint-disable-next-line no-unsafe-finally
      return {
        items,
      }
    }
  }

  async cloneOfferte(clone){
    let items = {}

    const url = `${this.baseUrl}/clienti/agenti/clona-offerte`
    
    try {
      let res = await this.http.post(url, clone)
      items = res.data

    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
      this.eventBus.emit('data-loaded')      
      // eslint-disable-next-line no-unsafe-finally
      return {
        items
      }
    }
  }

  async getFattureAperte(idAgente) {
    let items = {}
    const url = `${this.baseUrl}/clienti/agenti/fatture-aperte/${idAgente}`
  
    try {
      let res = await this.http.get(url)
      items = res.data
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
      this.eventBus.emit('data-loaded')      
      // eslint-disable-next-line no-unsafe-finally
      return {
        items,
      }
    }
  }

  async getCreditiUscitiInfo(){
    let items = []
  
    const url = `${this.baseUrl}/clienti/agenti/crediti-usciti-info`
    try {
      let res = await this.http.get(url)
      items = res.data
      return { items }
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
      return { items }
    } finally {
      this.eventBus.emit('data-loaded')
    }
  }

  async getProvvigioniAgenti(idAgente, anno) {
    let items = {}
    const url = `${this.baseUrl}/clienti/agenti/provvigioni`
  
    try {
      let res = await this.http.get(url, {
        params: {
          id_agente: idAgente,
          anno: anno
        }
      })
      items = res.data
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
      this.eventBus.emit('data-loaded')      
      // eslint-disable-next-line no-unsafe-finally
      return {
        items,
      }
    }
  }

}
